(function (w, d) {
	const body = d.querySelector('.js-body');
	const headerArea = d.querySelector('.js-header-area');
	const hamburger = d.querySelector('.js-hamburger');
	const nav = d.querySelector('.js-nav');
	const logoTitle = d.querySelector('.js-logo-title');

	function toggleHeaderMenu(e) {
		body.classList.toggle('is-open');
		headerArea.classList.toggle('header__area_is-active');
		hamburger.classList.toggle('hamburger_is-active');
		nav.classList.toggle('nav_is-active');
		if (logoTitle.classList.contains('is-black')) {
			logoTitle.classList.remove('is-black');
		} else {
			logoTitle.classList.add('is-black');
		}
	}

	hamburger.addEventListener('click', toggleHeaderMenu);
})(window, document);
